import { cn } from "@/lib/utils";
import { Expert } from "@/types/types";
import { Button } from "../ui/button";
import { ExpertAvatar } from "./ExpertAvatar";

type ExpertButtonProps = React.ComponentProps<typeof Button> & {
  expert: Pick<Expert, "name" | "profilePicture">;
  disableHover?: boolean;
};

export const ExpertButton = ({
  expert,
  className,
  ...rest
}: ExpertButtonProps) => {
  return (
    <Button
      className={cn(
        "flex flex-row items-center gap-2 pl-[2px] text-xs",
        "bg-foreground-2",
        className,
        {
          "pointer-events-none": rest.disableHover,
        },
      )}
      variant="secondary"
      {...rest}
    >
      <ExpertAvatar expert={expert} size="sm" invertColors />
      {expert.name}
    </Button>
  );
};
